import styled from 'styled-components';

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 16px;

  input,
  textarea,
  select {
    width: 100%;
  }
`;

export { FieldWrapper };
